var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkAsUnreadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.939,
    height: 14.253,
    viewBox: "0 0 17.939 14.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unread_message",
    "data-name": "Unread message",
    transform: "translate(-765.09 -575.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail-unread-outline",
    transform: "translate(765.84 575.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M58.437,96h-8.9A1.535,1.535,0,0,0,48,97.535v9.209a1.535,1.535,0,0,0,1.535,1.535H62.379a1.535,1.535,0,0,0,1.535-1.535v-5.257",
    transform: "translate(-48 -94.776)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M112,160l5.526,4.3,3.338-2.52",
    transform: "translate(-109.544 -156.32)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 1.84,
    cy: 1.84,
    r: 1.84,
    transform: "translate(12.893 0.614)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M370.5,69.008a2.454,2.454,0,1,1,2.454-2.454A2.454,2.454,0,0,1,370.5,69.008Zm0-3.68a1.228,1.228,0,1,0,1.226,1.228A1.228,1.228,0,0,0,370.5,65.328Z",
    transform: "translate(-355.769 -64.1)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsUnreadIcon);
export default __webpack_public_path__ + "static/media/mark-as-unread-icon.58a77dfcb447f037604ca914145feef5.svg";
export { ForwardRef as ReactComponent };